var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIconBlueBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 57,
    viewBox: "0 0 59 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5 57C13.7599 57 1 44.2401 1 28.5C1 12.7599 13.7599 0 29.5 0C45.2401 0 58 12.7599 58 28.5C58 44.2401 45.2401 57 29.5 57ZM26.8281 26.7187C26.8281 25.2431 28.0244 24.0469 29.5 24.0469C30.9756 24.0469 32.1719 25.2431 32.1719 26.7187V42.75C32.1719 44.2256 30.9756 45.4219 29.5 45.4219C28.0244 45.4219 26.8281 44.2256 26.8281 42.75V26.7187ZM29.5 19.5938C31.4675 19.5938 33.0625 17.9988 33.0625 16.0312C33.0625 14.0637 31.4675 12.4688 29.5 12.4688C27.5325 12.4687 25.9375 14.0637 25.9375 16.0312C25.9375 17.9988 27.5325 19.5937 29.5 19.5938Z",
    fill: "#00B0CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconBlueBackground);
export default __webpack_public_path__ + "static/media/InfoIconBlueBackground.4b6da802fe89c93d037e650a69d5f10d.svg";
export { ForwardRef as ReactComponent };